<template>
  <b-container class="text-image-container" :style="wrapperStyles">
    <b-row cols="1" cols-md="2">
      <b-col md="7" class="image-container" :class="{ 'order-12': !imageFirst }">
        <slot></slot>
      </b-col>
      <b-col md="5" class="texts">
        <b-container>
          <h2 class="title">{{ title }}</h2>
          <div class="subtitle">
            {{ subtitle }}
          </div>
          <div class="plans-button">
            <Button :to="buttonLink">{{ buttonText }}</Button>
          </div>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Button from 'UI/Button';
export default {
  components: {
    Button
  },
  props: {
    imageFirst: {
      type: Boolean,
      default: false
    },
    landingLink: {
      type: String,
      required: false,
      default: ''
    },
    link: {
      type: String,
      required: false,
      default: ''
    },
    Icon: {
      type: String,
      default: ''
    },
    marginVertical: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    }
  },
  computed: {
    wrapperStyles() {
      return this.marginVertical ? `margin: ${this.marginVertical}px auto` : '';
    },
    buttonLink() {
      const actualLink = this.landingLink
        ? this.$urlBuilder('landing', { uid: this.landingLink })
        : this.link
        ? this.$trailingSlash(this.localePath(this.link))
        : this.$urlBuilder('plans');
      return actualLink;
    }
  }
};
</script>

<style scoped>
.text-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 45px 0;
}
.text-image-container .texts {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.image-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
img {
  width: 100%;
  height: 100%;
}
.title {
  font-weight: 500;
  font-size: 30px;
}
.subtitle {
  font-size: 0.9em;
  margin-top: 25px;
}
.plans-button {
  margin-top: 50px;
}
</style>
